import React from "react";
import { connect } from "react-redux";

import { IconHamburger } from "~/components/icon";

import { openMainMenu } from "../../app/state/layout/LayoutActions";
import { queryAllDashboards } from "../../queries/dashboards";
import { useQueryClient } from "../../queries/react-query";

export interface HamburgerMenuProps {
	openMainMenu: () => void;
}

export const HamburgerMenuComponent = ({ openMainMenu }: HamburgerMenuProps) => {
	const queryClient = useQueryClient();

	return (
		<div
			className="h-10 w-10 cursor-pointer bg-primary-600 text-white transition-colors duration-200 hover:bg-primary-500 hover:text-white"
			data-testid="hamburger-menu"
			data-tourid="hamburger-menu"
			data-trackid="tm-hamburger_icon"
			id="hamburger-menu"
			onClick={openMainMenu}
			onMouseEnter={() => {
				// start prefetching when a user hovers the hamburger menu
				void queryAllDashboards.prefetchData(queryClient);
			}}
		>
			<IconHamburger className="h-full p-2 text-[40px]" type="hamburgerMenu" />
		</div>
	);
};

const HamburgerMenuConnected = connect(undefined, { openMainMenu })(HamburgerMenuComponent);

export const HamburgerMenu: React.FC = () => <HamburgerMenuConnected />;
